var jsonData = {
  table_header:[
    'Material Name',
    'Software',
    'Thickness(mm)',
    'Line Interval / Quality',
    'Processing',
    'Speed(mm/min)',
    'Max-Power / S-Max',
    'Image Mode',
    'Number of Passes'
  ],
  A20prov2: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 20000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "9mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "100%",
      mode: "-",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 20000,
      max: 900,
      mode: "-",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 120,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "17mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 20000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 20000,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 150,
      max: "100%",
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 20000,
      max: 800,
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 800,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 150,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "Cork Wood",
      software: "LightBurn",
      thickness: "16mm",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: "80%",
      mode: "-",
      number: 6,
    },
    {
      name: "Cork Wood",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Cork Wood",
      software: "LaserGRBL",
      thickness: "16mm",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 6,
    },
    {
      name: "Cork Wood",
      software: "LaserGRBL",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Yellow Peach Wood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Yellow Peach Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "15",
      quality: "-",
      processing: "Cutting",
      speed: 150,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "4.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 50,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 8000,
      max: 600,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 150,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "4.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 50,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Ceramic Tile",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Ceramic Tile",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: "800",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: 1500,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: 10000,
      max: 300,
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.6mm",
      quality: "-",
      processing: "Cutting",
      speed: 10000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Office Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 20000,
      max: "70%",
      mode: "Filled(One-way scanning)",
      number: 1,
    },
    {
      name: "Office Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 20000,
      max: 700,
      mode: "Filled(One-way scanning)",
      number: 1,
    },
    {
      name: "Oil Painting Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 20000,
      max: "40%",
      mode: "Stucki",
      number: "-",
    },
    {
      name: "Oil Painting Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 20000,
      max: 400,
      mode: "Stucki",
      number: "-",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 20000,
      max: "80%",
      mode: "Threshold(One-way scanning)",
      number: 1,
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 20000,
      max: 800,
      mode: "Threshold(One-way scanning)",
      number: 1,
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 20000,
      max: "60%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 250,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 20000,
      max: 600,
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 250,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Stainless Steel Sheet",
      software: "LightBurn",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Stainless Steel Sheet",
      software: "LaserGRBL",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Mirror Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 600,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Mirror Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 600,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Jarvis",
      number: 1,
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "100%",
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: 800,
      mode: "Jarvis",
      number: 1,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Alumina",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Alumina",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 6000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 6000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 20000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 20000,
      max: 700,
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Plastic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 20000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 20000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "80%",
      mode: "Threshold(One-way scanning)",
      number: 1,
    },
    {
      name: "Carton",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: 800,
      mode: "Threshold(One-way scanning)",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 650,
      max: "100%",
      mode: "-",
      number: 4,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "3mm",
      quality: "-",
      processing: "Cutting",
      speed: 160,
      max: "100%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: 400,
      mode: "Stucki",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 650,
      max: 1000,
      mode: "-",
      number: 4,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "3mm",
      quality: "-",
      processing: "Cutting",
      speed: 160,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "Galvanized Iron",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 1000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Galvanized Iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 1000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Rock",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Filled",
      number: 1,
    },
    {
      name: "Rock",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: 600,
      mode: "Filled",
      number: 1,
    },
    {
      name: "Crystal Stone",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Crystal Stone",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "800",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Mahogany",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Mahogany",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: 700,
      mode: "-",
      number: 1,
    },
    {
      name: "PCB Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "PCB Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "High Density Foam Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "High Density Foam Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: 300,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Two Color Plate",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Two Color Plate",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: 500,
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Resin",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 4000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Resin",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 4000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Artificial Beef Bone",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "65%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Artificial Beef Bone",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: 650,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Rubber",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Rubber",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Iron Sheet",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 1000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Iron Sheet",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Artificial Agate",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 500,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Artificial Agate",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 500,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Cobblestone",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 6000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Cobblestone",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 6000,
      max: 800,
      mode: "Threshold",
      number: 1,
    },
  ],
  A10prov2: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 6000,
      max: "70%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "6mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: 700,
      mode: "-",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "6mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: 1000,
      mode: "-",
      number: 10,
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 5000,
      max: "50%",
      mode: "Jarvis",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: "80%",
      mode: "-",
      number: 8,
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 190,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 5000,
      max: 500,
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: 1000,
      mode: "-",
      number: 8,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 190,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "Yellow Peach Wood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 6000,
      max: "60%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Yellow Peach Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: "600",
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 6000,
      max: "70%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 150,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 8000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 150,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "10",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "3mm",
      quality: "-",
      processing: "Cutting",
      speed: 80,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: 400,
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: 1000,
      mode: "-",
      number: 10,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "3mm",
      quality: "-",
      processing: "Cutting",
      speed: 80,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "Ceramic Tile",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 500,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Ceramic Tile",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 500,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: 6000,
      max: "60%",
      mode: "Jarvis",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: 6000,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "Office Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "30%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Office Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: 300,
      mode: "-",
      number: 1,
    },
    {
      name: "Oil Painting Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "5%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Oil Painting Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: 50,
      mode: "-",
      number: "1",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 5000,
      max: "60%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 8000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: 700,
      mode: "-",
      number: 1,
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 300,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 300,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "6mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "80%",
      mode: "-",
      number: 10,
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: "100%",
      mode: "-",
      number: 10,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 6000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "6mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: 1000,
      mode: "-",
      number: 10,
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 500,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Alumina",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 300,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Alumina",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 300,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 400,
      max: "60%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 400,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 6000,
      max: "70%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: 700,
      mode: "-",
      number: 1,
    },
    {
      name: "Plastic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 2000,
      max: "80%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 5000,
      max: "60%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Carton",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 5000,
      max: 600,
      mode: "Threshold",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 6000,
      max: "20%",
      mode: "Atkinson",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 6000,
      max: 200,
      mode: "-",
      number: 1,
    },
    {
      name: "Rock",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 5000,
      max: "70%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Rock",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 5000,
      max: 700,
      mode: "-",
      number: 1,
    },
    {
      name: "Crystal Stone",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 800,
      max: "65%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Crystal Stone",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 800,
      max: "650",
      mode: "-",
      number: 1,
    },
    {
      name: "Mahogany",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 6000,
      max: "60%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Mahogany",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 6000,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "PCB Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 600,
      max: "20%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "PCB Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 600,
      max: 200,
      mode: "-",
      number: 1,
    },
    {
      name: "High Density Foam Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 5000,
      max: "30%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "High Density Foam Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 5000,
      max: 300,
      mode: "-",
      number: 1,
    },
    {
      name: "Two Color Plate",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 5000,
      max: "35%",
      mode: "Threshold（ overscanning）",
      number: 1,
    },
    {
      name: "Two Color Plate",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 5000,
      max: 350,
      mode: "-",
      number: 1,
    },
    {
      name: "Rubber",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "70%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Rubber",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 700,
      mode: "-",
      number: 1,
    },
    {
      name: "Translucent Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Jarvis",
      number: 1,
    },
    {
      name: "Translucent Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
    },
    {
      name: "Cobblestone",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "70%",
      mode: "Jarvis",
      number: 1,
    },
    {
      name: "Cobblestone",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 700,
      mode: "-",
      number: 1,
    },
  ],
  A40prov2: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.09,
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: "800",
      mode: "-",
      number: 9,
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "11mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 11,
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "-",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: 800,
      mode: "-",
      number: 9,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "11mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 750,
      max: "700",
      mode: "-",
      number: 9,
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 750,
      max: 700,
      mode: "-",
      number: 9,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Cork Wood",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: "1000",
      mode: "-",
      number: 1,
    },
    {
      name: "Cork Wood",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "Yellow Peach Wood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Yellow Peach Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "800",
      mode: "-",
      number: 10,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Ceramic Tile",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Ceramic Tile",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "-",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.6mm",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Office Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "47%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Office Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "47%",
      mode: "-",
      number: 1,
    },
    {
      name: "Glutinous rice paper",
      software: "LightBurn",
      thickness: "0.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "Glutinous rice paper",
      software: "LaserGRBL",
      thickness: "0.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: 800,
      mode: "-",
      number: "-",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "-",
      number: 1,
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "45%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "600",
      mode: "-",
      number: 5,
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "45%",
      mode: "-",
      number: 1,
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 5,
    },
    {
      name: "Stainless Steel Sheet",
      software: "LightBurn",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "600",
      mode: "-",
      number: 1,
    },
    {
      name: "Stainless Steel Sheet",
      software: "LaserGRBL",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: "800",
      mode: "-",
      number: 10,
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Alumina",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "65%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Alumina",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "65%",
      mode: "-",
      number: 1,
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "Plastic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "35%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Carton",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "35%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "800",
      mode: "-",
      number: 7,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 350,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 7,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 350,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Galvanized Iron",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Galvanized Iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Rock",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Rock",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "-",
      number: 1,
    },
    {
      name: "High Density Foam Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "25%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "High Density Foam Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "25%",
      mode: "-",
      number: 1,
    },
    {
      name: "Two Color Plate",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Two Color Plate",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "EVa Foam",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: 1500,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "EVa Foam",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: 1500,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Drywall",
      software: "LightBurn",
      thickness: "15",
      quality: "-",
      processing: "Engraving",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Drywall",
      software: "LaserGRBL",
      thickness: "15",
      quality: "-",
      processing: "Engraving",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Rubber",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Rubber",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "-",
      number: 1,
    },
    {
      name: "Iron Sheet",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Iron Sheet",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Woolen Blanket",
      software: "LightBurn",
      thickness: "0.2",
      quality: "-",
      processing: "Cutting",
      speed: 4000,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Woolen Blanket",
      software: "LaserGRBL",
      thickness: "0.2",
      quality: "-",
      processing: "Cutting",
      speed: 4000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Wrench (chrome - vanadium alloy)",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Wrench (chrome - vanadium alloy)",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Brass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Brass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "0.1",
      quality: "-",
      processing: "Cutting",
      speed: 4000,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "0.1",
      quality: "-",
      processing: "Cutting",
      speed: 4000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "PCB Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "PCB Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
  ],
  A70Max: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: "0.09",
      processing: "Engraving",
      speed: "10000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: "1200",
      max: "90%",
      mode: "-",
      number: "10",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "15",
      quality: "-",
      processing: "Cutting",
      speed: "300",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: "1200",
      max: "900",
      mode: "-",
      number: "10",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "15",
      quality: "-",
      processing: "Cutting",
      speed: "300",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Yellow peach wood",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "40%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Yellow peach wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "400",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "40%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "25",
      quality: "-",
      processing: "Cutting",
      speed: "1100",
      max: "90%",
      mode: "-",
      number: "10",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: "120",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "400",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "25",
      quality: "-",
      processing: "Cutting",
      speed: "1100",
      max: "900",
      mode: "-",
      number: "10",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: "120",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "90%",
      mode: "-",
      number: "2",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "18",
      quality: "-",
      processing: "Cutting",
      speed: "350",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "900",
      mode: "-",
      number: "2",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "18",
      quality: "-",
      processing: "Cutting",
      speed: "350",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Cork wood",
      software: "LightBurn",
      thickness: "18",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Cork wood",
      software: "LaserGRBL",
      thickness: "18",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "45%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "450",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "35%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "4",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "90%",
      mode: "-",
      number: "5",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "350",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "4",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "900",
      mode: "-",
      number: "5",
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "20%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "200",
      mode: "-",
      number: "1",
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "Ceramic Tile",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "8000",
      max: "30%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Ceramic Tile",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "8000",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "Alumina",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "55%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Alumina",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "550",
      mode: "-",
      number: "1",
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "6000",
      max: "50%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "6000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "50%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "26",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "90%",
      mode: "-",
      number: "10",
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "26",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "900",
      mode: "-",
      number: "10",
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Translucent Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "8000",
      max: "30%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Translucent Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "8000",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "Two color plate",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "7000",
      max: "20%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Two color plate",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "7000",
      max: "200",
      mode: "-",
      number: "1",
    },
    {
      name: "Plastic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "45%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "10000",
      max: "450",
      mode: "-",
      number: "1",
    },
    {
      name: "High density foam board",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "8000",
      max: "13%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "High density foam board",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "8000",
      max: "130",
      mode: "-",
      number: "1",
    },
    {
      name: "Rubber",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "8000",
      max: "35%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Rubber",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "8000",
      max: "350",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "9000",
      max: "30%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: "9000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "9000",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: "9000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Office Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "27%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Office Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "270",
      mode: "-",
      number: "1",
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "8000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Carton",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "8000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: "0.09",
      processing: "Engraving",
      speed: "10000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "12",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "90%",
      mode: "-",
      number: "6",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "9",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: "11",
      processing: "Engraving",
      speed: "10000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "12",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "900",
      mode: "-",
      number: "6",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "9",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Galvanized Iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Stainless Steel Sheet",
      software: "LightBurn",
      thickness: "0.05",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "60%",
      mode: "-",
      number: "1",
    },
    {
      name: "Stainless Steel Sheet",
      software: "LaserGRBL",
      thickness: "0.05",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "EVa Foam",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: "1500",
      max: "30%",
      mode: "-",
      number: "1",
    },
    {
      name: "EVa Foam",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: "1500",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "Glutinous rice paper",
      software: "LightBurn",
      thickness: "0.5",
      quality: "-",
      processing: "Cutting",
      speed: "500",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Glutinous rice paper",
      software: "LaserGRBL",
      thickness: "0.5",
      quality: "-",
      processing: "Cutting",
      speed: "500",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Woolen Blanket",
      software: "LightBurn",
      thickness: "1.5",
      quality: "-",
      processing: "Cutting",
      speed: "2000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Woolen Blanket",
      software: "LaserGRBL",
      thickness: "1.5",
      quality: "-",
      processing: "Cutting",
      speed: "2000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "denim",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: "5000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "denim",
      software: "LaserGRBL",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: "5000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "35%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "350",
      mode: "-",
      number: "1",
    },
    {
      name: "Rock",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Rock",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "10000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "Crystal Stone",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "7000",
      max: "40%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Crystal Stone",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "7000",
      max: "400",
      mode: "-",
      number: "1",
    },
    {
      nname: "PCB Board",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "8000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "PCB Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "8000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "Hard maple",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Hard maple",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "10000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "6000",
      max: "50%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: "15",
      processing: "Engraving",
      speed: "6000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "Galvanized iron",
      software: "LightBurn",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "3000",
      max: "90%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Galvanized iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: "15",
      processing: "Engraving",
      speed: "3000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Brass",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "2000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Brass",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "2000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Wrench (chrome -vanadium alloy)",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "3000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Wrench (chrome -vanadium alloy)",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "3000",
      max: "800",
      mode: "-",
      number: "1",
    },
  ],
  AtomStackKraft: [
    {
      type: "title",
      content: "AtomStack Kraft 20W Didoe Laser Parameters",
    },
    {
      name: "Basswood",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Basswood",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "8%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Basswood",
      software: "-",
      thickness: "6mm",
      quality: "-",
      processing: "Cutting",
      speed: "120",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Basswood",
      software: "-",
      thickness: "7mm",
      quality: "-",
      processing: "Cutting",
      speed: "500",
      max: "80%",
      mode: "-",
      number: "10",
    },
    {
      name: "Pine",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Pine",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "15%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Pine",
      software: "-",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "-",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: "300",
      max: "80%",
      mode: "-",
      number: "10",
    },
    {
      name: "peach wood",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "peach wood",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "10%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Mahogany",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Mahogany",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "8%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "25000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "30%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Paulownia wood",
      software: "-",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia wood",
      software: "-",
      thickness: "13mm",
      quality: "-",
      processing: "Cutting",
      speed: "850",
      max: "80%",
      mode: "-",
      number: "10",
    },
    {
      name: "Bamboo",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "20%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "-",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "250",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "60%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Leather",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "30%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Leather",
      software: "-",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "3000",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Denim",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Ceramics",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "2000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Ceramics",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "60%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Ceramic Tile",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "2000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Ceramic Tile",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "60%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Alumina",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Alumina",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "20%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Glass",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Glass",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "30%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "8000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "30%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "-",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "60",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "-",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "10",
    },
    {
      name: "Two color plate",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Two color plate",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "8%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Plastic",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Plastic",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "15%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "6%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Cork wood",
      software: "-",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: "550",
      max: "80%",
      mode: "-",
      number: "1",
    },

    {
      name: "Kraft Paper",
      software: "-",
      thickness: "0.6mm",
      quality: "-",
      processing: "Cutting",
      speed: "1500",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Office Paper",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "18000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Oil Painting Paper",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "40%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Oil Painting Paper",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "7%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Carton",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "Carton",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "6%",
      mode: "Line",
      number: "1",
    },
    {
      name: "MDF",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "MDF",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "6%",
      mode: "Line",
      number: "1",
    },
    {
      name: "MDF",
      software: "-",
      thickness: "3mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "-",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "500",
      max: "80%",
      mode: "-",
      number: "7",
    },
    {
      name: "Brushed Stainless Steel",
      software: "Bitmap",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "6000",
      max: "100%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "100%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Mirrors Back",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "12000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Mirrors Back",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "8%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Rock",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Rock",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "20%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Crystal Stone",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Crystal Stone",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "40%",
      mode: "Line",
      number: "1",
    },
    {
      name: "PCB Board",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "4500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Galvanized iron",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Galvanized iron",
      software: "Vector Line",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "100",
      max: "80%",
      mode: "Line",
      number: "1",
    },

    {
      name: "Stainless Steel Sheet",
      software: "-",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Blanket",
      software: "-",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: "1500",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Felt cloth",
      software: "-",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: "700",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Carton",
      software: "-",
      thickness: "6mm",
      quality: "-",
      processing: "Cutting",
      speed: "600",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Denim",
      software: "-",
      thickness: "0.5mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      type: "title",
      content: "AtomStack Kraft 1.2W Infrared Laser Parameters",
    },
    {
      name: "Copper",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "1000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Copper",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "80% on Constant Power mode",
      mode: "Line",
      number: "1",
    },
    {
      name: "Iron",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "2000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Iron",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "80% on Constant Power mode",
      mode: "Line",
      number: "1",
    },
    {
      name: "Natural color alumina",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "1000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "3000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "60% on Constant Power mode",
      mode: "Line",
      number: "1",
    },
    {
      name: "Mirror Back",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Mirror Back",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "300",
      max: "80% on Constant Power mode",
      mode: "Line",
      number: "1",
    },
    {
      name: "Coated alumina",
      software: "Bitmap",
      thickness: "-",
      quality: "0.02",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Coated alumina",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "30% on Constant Power mode",
      mode: "Line",
      number: "1",
    },
    {
      name: "painted furniture",
      software: "Bitmap",
      thickness: "-",
      quality: "0.02",
      processing: "Engraving",
      speed: "4000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ABS",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "5000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ABS",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "30%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Colored plastics",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "4000",
      max: "60%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Colored plastics",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "35%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Leather",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "5000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Leather",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "20%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "Bitmap",
      thickness: "-",
      quality: "0.02",
      processing: "Engraving",
      speed: "2000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Rock",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "5000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Rock",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Mobile phone case",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Mobile phone case",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "2000",
      max: "50%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Aluminum Business Card",
      software: "Bitmap",
      thickness: "-",
      quality: "0.02",
      processing: "Engraving",
      speed: "5000",
      max: "60%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Aluminum Business Card",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "100%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Green plastic",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "1000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Green plastic",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "Line",
      number: "1",
    },
    {
      name: "Galvanized iron",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "2000",
      max: "100% on Constant Power mode",
      mode: "Threshold",
      number: "1",
    },
    {
      type: "title",
      content: "AtomStack Kraft 20W+1.2W Dual Laser Parameters",
    },
    {
      name: "Copper",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "2500",
      max: "100% on Constant Power mode",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Brushed Stainless Stee",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "4000",
      max: "100% on Constant Power mode",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Galvanized iron",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "8000",
      max: "100% on Constant Power mode",
      mode: "Threshold",
      number: "1",
    },
  ],
  AtomStackP1: [
    {
      type: "title",
      content: "AtomStack P1 1.2W Infrared Laser Parameters",
    },
    {
      name: "Brass",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "1500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Brass",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "3500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Coated alumina",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Coated alumina",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "60%",
      mode: "NA",
      number: "NA",
    },
    {
      name: "Black alumina",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "10000",
      max: "70%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Black alumina",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "60%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Stainless Steel",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "3500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Stainless Steel",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "60%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Painted furniture",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "5000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Painted furniture",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "65%",
      mode: "NA",
      number: "1",
    },
    {
      name: "ABS",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "ABS",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "35%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Plastic",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Plastic",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "30%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Leather",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "10000",
      max: "60%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Leather",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Black acrylic",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "10000",
      max: "40%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Black acrylic",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "50%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Rubber",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "8000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Rubber",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "30%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Metal business card",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "10000",
      max: "40%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Metal business card",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "55%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Rock",
      software: "Bitmap",
      thickness: "-",
      quality: "0.01",
      processing: "Engraving",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Rock",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "500",
      max: "70%",
      mode: "NA",
      number: "1",
    },
    {
      type: "title",
      content: "AtomStack P1 5W Diode Laser Parameters",
    },
    {
      name: "Basswood",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "9000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Basswood",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "20%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Yellow peach wood",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "8000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Yellow peach wood",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Pine",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "5000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Pine",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "30%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Paulownia wood",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "8000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Paulownia wood",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "7000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "20%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Beech",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "8000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Beech",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "20%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "9000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "MDF",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "70%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "MDF",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Aluminum card",
      software: "Bitmap",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "100",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Aluminum card",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "100",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Leather",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Leather",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "20%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Plastic",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "8000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Plastic",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "20%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Rubber",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "70%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Rubber",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Denim",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "70%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ceramics",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "200",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "ceramics",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "100",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Ceramic tile",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "800",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Ceramic tile",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "300",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Black alumina",
      software: "Bitmap",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "1000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Black alumina",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Glass",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "800",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Glass",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "400",
      max: "80%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Black acrylic",
      software: "Bitmap",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "5000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Black acrylic",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "25%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Two color plate",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "8000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Two color plate",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Carton",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "8000",
      max: "65%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Carton",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Mirrors",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "3000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Mirrors",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "60%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Leaf",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "80%",
      mode: "Stucki(Negative engraving)",
      number: "1",
    },
    {
      name: "Leaf",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "10%",
      mode: "NA",
      number: "1", 
    },
    {
      name: "Rock",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Rock",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "30%",
      mode: "NA",
      number: "1", 
    },
    {
      name: "Stainless Steel",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "1500",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Stainless Steel",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "100",
      max: "80%",
      mode: "NA",
      number: "1", 
    },
    {
      name: "Painted furniture",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Painted furniture",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "20%",
      mode: "NA",
      number: "1", 
    },
    {
      name: "Laser debugging paper",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "10%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Laser debugging paper",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "1000",
      max: "15%",
      mode: "NA",
      number: "1", 
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "3mm",
      quality: "-",
      processing: "Cutting",
      speed: 120,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 120,
      max: "80%",
      mode: "-",
      number: 2,
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "4mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "80%",
      mode: "Stucki",
      number: 2,
    },
    {
      name: "Paulownia wood",
      software: "LightBurn",
      thickness: "4mm",
      quality: "-",
      processing: "Cutting",
      speed: 150,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia wood",
      software: "LightBurn",
      thickness: "7mm",
      quality: "-",
      processing: "Cutting",
      speed: 150,
      max: "80%",
      mode: "-",
      number: 3,
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "1mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.6mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Felt cloth",
      software: "LightBurn",
      thickness: "3mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "80%",
      mode: "-",
      number: 3,
    },
    {
      name: "Woolen Blanket",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "0.7mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "6mm",
      quality: "-",
      processing: "Cutting",
      speed: 150,
      max: "80%",
      mode: "-",
      number: 1,
    }
  ],
  AtomStackHurricane: [
    {
      name: "Basswood",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "18000",
      max: "30%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Basswood",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "6%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Basswood",
      software: "-",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Basswood",
      software: "-",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: "150",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "Yellow peach wood",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "18000",
      max: "20%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Yellow peach wood",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3000",
      max: "5%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Pine",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "18000",
      max: "20%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Pine",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "5%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Pine",
      software: "-",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "-",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia wood",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "15000",
      max: "45%",
      mode: "Stucki",
      number: "NA",
    },
    {
      name: "Paulownia wood",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "6%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Paulownia wood",
      software: "-",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia wood",
      software: "-",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: "300",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia wood",
      software: "-",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "400",
      max: "80%",
      mode: "-",
      number: "2",
    },
    {
      name: "Bamboo",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "18000",
      max: "30%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3000",
      max: "8%",
      mode: "NA",
      number: "NA",
    },
    {
      name: "Bamboo",
      software: "-",
      thickness: "4mm",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "-",
      thickness: "4mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "Denim",
      software: "Vector Line",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "24000",
      max: "8%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Cork wood",
      software: "-",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: "1800",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "Cork wood",
      software: "-",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: "1200",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "24000",
      max: "20%",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "Bitmap",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "8%",
      mode: "-",
      number: "NA",
    },
    {
      name: "Leather",
      software: "-",
      thickness: "3mm",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Alumina",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "18000",
      max: "35%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Alumina",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "40%",
      mode: "NA",
      number: "NA",
    },
    {
      name: "Glass",
      software: "Bitmap",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "18000",
      max: "30%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Glass",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "15%",
      mode: "NA",
      number: "NA",
    },
    {
      name: "Black Acrylic",
      software: "Bitmap",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "9000",
      max: "15%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Black Acrylic",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "6%",
      mode: "NA",
      number: "NA",
    },
    {
      name: "Black Acrylic",
      software: "-",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: "300",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "Black Acrylic",
      software: "-",
      thickness: "6mm",
      quality: "-",
      processing: "Cutting",
      speed: "250",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "24000",
      max: "40%",
      mode: "Stucki",
      number: "-",
    },
    {
      name: "Kraft Paper",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "5%",
      mode: "NA",
      number: "-",
    },
    {
      name: "Kraft Paper",
      software: "-",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: "300",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "-",
      thickness: "6mm",
      quality: "-",
      processing: "Cutting",
      speed: "250",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Transparent acrylic",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "24000",
      max: "20%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Transparent acrylic",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "5%",
      mode: "NA",
      number: "NA",
    },
    {
      name: "Transparent acrylic",
      software: "-",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: "50",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "Transparent acrylic",
      software: "-",
      thickness: "3mm",
      quality: "-",
      processing: "Cutting",
      speed: "700",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Korrugated Cardboard",
      software: "Bitmap",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "24000",
      max: "30%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Korrugated Cardboard",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "6%",
      mode: "NA",
      number: "NA",
    },
    {
      name: "MDF",
      software: "Bitmap",
      thickness: "-",
      quality: "0.12",
      processing: "Engraving",
      speed: "24000",
      max: "25%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "MDF",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "8%",
      mode: "NA",
      number: "NA",
    },
    {
      name: "MDF",
      software: "-",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "500",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "-",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "600",
      max: "100%",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "-",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "80%",
      mode: "-",
      number: "5",
    },
    {
      name: "MDF",
      software: "-",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: "1100",
      max: "100%",
      mode: "-",
      number: "5",
    },
    {
      name: "Rock",
      software: "Bitmap",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "18000",
      max: "30%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Rock",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "15%",
      mode: "NA",
      number: "1",
    },
    {
      name: "PCB Board",
      software: "Bitmap",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "12000",
      max: "10%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "PCB Board",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "5%",
      mode: "NA",
      number: "1",
    },
    {
      name: "Brushed Stainless  Steel",
      software: "Bitmap",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "4000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "3500",
      max: "60% on Constant Power mode",
      mode: "NA",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "Bitmap",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "1000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "Vector Line",
      thickness: "-",
      quality: "NA",
      processing: "Engraving",
      speed: "700",
      max: "80%  on Constant Power mode",
      mode: "NA",
      number: "1",
    },
    {
      name: "EVA Foam",
      software: "-",
      thickness: "7.5mm",
      quality: "-",
      processing: "Cutting",
      speed: "3500",
      max: "70%",
      mode: "-",
      number: "1",
    },
    {
      name: "EVA Foam",
      software: "-",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: "4000",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Felt cloth",
      software: "-",
      thickness: "3mm",
      quality: "-",
      processing: "Cutting",
      speed: "3500",
      max: "40%",
      mode: "-",
      number: "1",
    },
    {
      name: "Denim",
      software: "-",
      thickness: "0.7mm",
      quality: "-",
      processing: "Cutting",
      speed: "3500",
      max: "40%",
      mode: "-",
      number: "1",
    },
    {
      name: "Denim",
      software: "-",
      thickness: "0.3mm",
      quality: "-",
      processing: "Cutting",
      speed: "3500",
      max: "10%",
      mode: "-",
      number: "1",
    },
    {
      name: "-",
      software: "0.5mm",
      thickness: "-",
      quality: "Cutting",
      processing: "3500",
      speed: "0.2",
      max: "-",
      mode: "1",
      number: "",
    },
    {
      name: "Korrugated Cardboard",
      software: "-",
      thickness: "6mm",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "60%",
      mode: "-",
      number: "1",
    },
  ],

  A24Pro: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: "120",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "17mm",
      quality: "-",
      processing: "Cutting",
      speed: "700",
      max: "80%",
      mode: "-",
      number: "10",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: "120",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "17mm",
      quality: "-",
      processing: "Cutting",
      speed: "700",
      max: "800",
      mode: "-",
      number: "10",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "650",
      max: "80%",
      mode: "-",
      number: "9",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "15000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "650",
      max: "800",
      mode: "-",
      number: "9",
    },
    {
      name: "peach wood",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "peach wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "Mahogany",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "80%",
      mode: "Stucki",
      number: "-",
    },
    {
      name: "Mahogany",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "60%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "80%",
      mode: "-",
      number: "8",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "800",
      mode: "-",
      number: "8",
    },
    {
      name: "Cork wood",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: "700",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Cork wood",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "80%",
      mode: "-",
      number: "3",
    },
    {
      name: "Cork wood",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: "700",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Cork wood",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "800",
      mode: "-",
      number: "3",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "400",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "400",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "2",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "15000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "2",
      quality: "-",
      processing: "Cutting",
      speed: "400",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "12000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "12000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Ceramic Tile",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Ceramic Tile",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Alumina",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Alumina",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "10000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "12000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "25mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "8",
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "12000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "25mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "800",
      mode: "-",
      number: "8",
    },
    {
      name: "Translucent Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "20%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "Translucent Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "200",
      mode: "-",
      number: "-",
    },
    {
      name: "Two color plate",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Two color plate",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Plastic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Rubber",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Rubber",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "20%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: "2000",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "200",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: "2000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Office Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Office Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Oil Painting Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "40%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "Oil Painting Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "400",
      mode: "-",
      number: "-",
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "50%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Carton",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "30000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "7mm",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "80%",
      mode: "-",
      number: "8",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "7mm",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "800",
      mode: "-",
      number: "8",
    },
    {
      name: "Stainless Steel Sheet",
      software: "LightBurn",
      thickness: "0.05",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Stainless Steel Sheet",
      software: "LaserGRBL",
      thickness: "0.05",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "25000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "25000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Rock",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "25000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Rock",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "25000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "maple",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "maple",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "15000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "Crystal Stone",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "Crystal Stone",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "PCB Board",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "7000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "PCB Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "7000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "3000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "3000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Galvanized iron",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "3000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Galvanized iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "3000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "1000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "1000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Brass",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Brass",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "500",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Wrench (chrome - vanadium alloy)",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Wrench (chrome - vanadium alloy)",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "500",
      max: "800",
      mode: "-",
      number: "1",
    },
  ],

  A40Pro: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.09,
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: "800",
      mode: "-",
      number: 9,
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "11mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 11,
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "-",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: 800,
      mode: "-",
      number: 9,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "11mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 750,
      max: "700",
      mode: "-",
      number: 9,
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 750,
      max: 700,
      mode: "-",
      number: 9,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Cork Wood",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: "1000",
      mode: "-",
      number: 1,
    },
    {
      name: "Cork Wood",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "Yellow Peach Wood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Yellow Peach Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "800",
      mode: "-",
      number: 10,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Ceramic Tile",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Ceramic Tile",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "-",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.6mm",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Office Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "47%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Office Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "47%",
      mode: "-",
      number: 1,
    },
    {
      name: "Glutinous rice paper",
      software: "LightBurn",
      thickness: "0.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "Glutinous rice paper",
      software: "LaserGRBL",
      thickness: "0.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: 800,
      mode: "-",
      number: "-",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "-",
      number: 1,
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "45%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "600",
      mode: "-",
      number: 5,
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "45%",
      mode: "-",
      number: 1,
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 5,
    },
    {
      name: "Stainless Steel Sheet",
      software: "LightBurn",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "600",
      mode: "-",
      number: 1,
    },
    {
      name: "Stainless Steel Sheet",
      software: "LaserGRBL",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: "800",
      mode: "-",
      number: 10,
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Alumina",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "65%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Alumina",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "65%",
      mode: "-",
      number: 1,
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "Plastic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "35%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Carton",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "35%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "800",
      mode: "-",
      number: 7,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 350,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 7,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 350,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Galvanized Iron",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Galvanized Iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Rock",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Rock",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "-",
      number: 1,
    },
    {
      name: "High Density Foam Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "25%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "High Density Foam Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "25%",
      mode: "-",
      number: 1,
    },
    {
      name: "Two Color Plate",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Two Color Plate",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "EVa Foam",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: 1500,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "EVa Foam",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: 1500,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Drywall",
      software: "LightBurn",
      thickness: "15",
      quality: "-",
      processing: "Engraving",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Drywall",
      software: "LaserGRBL",
      thickness: "15",
      quality: "-",
      processing: "Engraving",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Rubber",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Rubber",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "-",
      number: 1,
    },
    {
      name: "Iron Sheet",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Iron Sheet",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Woolen Blanket",
      software: "LightBurn",
      thickness: "0.2",
      quality: "-",
      processing: "Cutting",
      speed: 4000,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Woolen Blanket",
      software: "LaserGRBL",
      thickness: "0.2",
      quality: "-",
      processing: "Cutting",
      speed: 4000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Wrench (chrome - vanadium alloy)",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Wrench (chrome - vanadium alloy)",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Brass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Brass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "0.1",
      quality: "-",
      processing: "Cutting",
      speed: 4000,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "0.1",
      quality: "-",
      processing: "Cutting",
      speed: 4000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "PCB Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "PCB Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
  ],

  A40max: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.09,
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: "800",
      mode: "-",
      number: 9,
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "11mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 11,
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "-",
      number: 1,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: 800,
      mode: "-",
      number: 9,
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "11mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 750,
      max: "700",
      mode: "-",
      number: 9,
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 750,
      max: 700,
      mode: "-",
      number: 9,
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Cork Wood",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: "1000",
      mode: "-",
      number: 1,
    },
    {
      name: "Cork Wood",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: 1000,
      mode: "-",
      number: 1,
    },
    {
      name: "Yellow Peach Wood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Yellow Peach Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "800",
      mode: "-",
      number: 10,
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "-",
      number: 1,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Ceramic Tile",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Ceramic Tile",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: 10000,
      max: "40%",
      mode: "-",
      number: 1,
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.6mm",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Office Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "47%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Office Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "47%",
      mode: "-",
      number: 1,
    },
    {
      name: "Glutinous rice paper",
      software: "LightBurn",
      thickness: "0.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "Glutinous rice paper",
      software: "LaserGRBL",
      thickness: "0.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: 800,
      mode: "-",
      number: "-",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "-",
      number: 1,
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "45%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "600",
      mode: "-",
      number: 5,
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "45%",
      mode: "-",
      number: 1,
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 5,
    },
    {
      name: "Stainless Steel Sheet",
      software: "LightBurn",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "600",
      mode: "-",
      number: 1,
    },
    {
      name: "Stainless Steel Sheet",
      software: "LaserGRBL",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 1,
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: "800",
      mode: "-",
      number: 10,
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: 800,
      mode: "-",
      number: 10,
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "80%",
      mode: "-",
      number: 1,
    },
    {
      name: "Alumina",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "65%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Alumina",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "65%",
      mode: "-",
      number: 1,
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "Plastic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "50%",
      mode: "-",
      number: 1,
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "35%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Carton",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "35%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "800",
      mode: "-",
      number: 7,
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 350,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 7,
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 350,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Galvanized Iron",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Galvanized Iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Rock",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Rock",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "-",
      number: 1,
    },
    {
      name: "High Density Foam Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 10000,
      max: "25%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "High Density Foam Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 10000,
      max: "25%",
      mode: "-",
      number: 1,
    },
    {
      name: "Two Color Plate",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Two Color Plate",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "30%",
      mode: "-",
      number: 1,
    },
    {
      name: "EVa Foam",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: 1500,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "EVa Foam",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: 1500,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Drywall",
      software: "LightBurn",
      thickness: "15",
      quality: "-",
      processing: "Engraving",
      speed: 100,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Drywall",
      software: "LaserGRBL",
      thickness: "15",
      quality: "-",
      processing: "Engraving",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Rubber",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Rubber",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 10000,
      max: "55%",
      mode: "-",
      number: 1,
    },
    {
      name: "Iron Sheet",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Iron Sheet",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Woolen Blanket",
      software: "LightBurn",
      thickness: "0.2",
      quality: "-",
      processing: "Cutting",
      speed: 4000,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Woolen Blanket",
      software: "LaserGRBL",
      thickness: "0.2",
      quality: "-",
      processing: "Cutting",
      speed: 4000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "Wrench (chrome - vanadium alloy)",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "Threshold",
      number: 1,
    },
    {
      name: "Wrench (chrome - vanadium alloy)",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Brass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "Brass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "0.1",
      quality: "-",
      processing: "Cutting",
      speed: 4000,
      max: "800",
      mode: "-",
      number: 1,
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "0.1",
      quality: "-",
      processing: "Cutting",
      speed: 4000,
      max: 800,
      mode: "-",
      number: 1,
    },
    {
      name: "PCB Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 10000,
      max: "70%",
      mode: "Stucki",
      number: 1,
    },
    {
      name: "PCB Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 1000,
      max: "90%",
      mode: "-",
      number: 1,
    },
  ],

  A24Ultra: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: "120",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "17mm",
      quality: "-",
      processing: "Cutting",
      speed: "700",
      max: "80%",
      mode: "-",
      number: "10",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: "120",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "17mm",
      quality: "-",
      processing: "Cutting",
      speed: "700",
      max: "800",
      mode: "-",
      number: "10",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "650",
      max: "80%",
      mode: "-",
      number: "9",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "15000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "650",
      max: "800",
      mode: "-",
      number: "9",
    },
    {
      name: "peach wood",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "peach wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "Mahogany",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "80%",
      mode: "Stucki",
      number: "-",
    },
    {
      name: "Mahogany",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "60%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "80%",
      mode: "-",
      number: "8",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "800",
      mode: "-",
      number: "8",
    },
    {
      name: "Cork wood",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: "700",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Cork wood",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "80%",
      mode: "-",
      number: "3",
    },
    {
      name: "Cork wood",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: "700",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Cork wood",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "800",
      mode: "-",
      number: "3",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "400",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "400",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "2",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "15000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "2",
      quality: "-",
      processing: "Cutting",
      speed: "400",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "12000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "12000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Ceramic Tile",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Ceramic Tile",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Alumina",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Alumina",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "10000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "12000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "25mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "80%",
      mode: "-",
      number: "8",
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "12000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "25mm",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "800",
      mode: "-",
      number: "8",
    },
    {
      name: "Translucent Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "20%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "Translucent Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "200",
      mode: "-",
      number: "-",
    },
    {
      name: "Two color plate",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Two color plate",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Plastic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Rubber",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Rubber",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "20%",
      mode: "Jarvis",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: "2000",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "200",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: "2000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Office Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "20000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Office Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "20000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Oil Painting Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "40%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "Oil Painting Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "400",
      mode: "-",
      number: "-",
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "30000",
      max: "50%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Carton",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "30000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "30000",
      max: "80%",
      mode: "Stucki",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "7mm",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "80%",
      mode: "-",
      number: "8",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "30000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "7mm",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "800",
      mode: "-",
      number: "8",
    },
    {
      name: "Stainless Steel Sheet",
      software: "LightBurn",
      thickness: "0.05",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "80%",
      mode: "-",
      number: "1",
    },
    {
      name: "Stainless Steel Sheet",
      software: "LaserGRBL",
      thickness: "0.05",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "25000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "25000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Rock",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "25000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Rock",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "25000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "maple",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "15000",
      max: "80%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "maple",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "15000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "Crystal Stone",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "80%",
      mode: "Threshold",
      number: "-",
    },
    {
      name: "Crystal Stone",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "800",
      mode: "-",
      number: "-",
    },
    {
      name: "PCB Board",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "7000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "PCB Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "7000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "3000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "3000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Galvanized iron",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "3000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Galvanized iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "3000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "1000",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "1000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Brass",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Brass",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "500",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Wrench (chrome - vanadium alloy)",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "500",
      max: "80%",
      mode: "Threshold",
      number: "1",
    },
    {
      name: "Wrench (chrome - vanadium alloy)",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "500",
      max: "800",
      mode: "-",
      number: "1",
    },
  ],

  A70Pro: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: "0.09",
      processing: "Engraving",
      speed: "10000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: "1200",
      max: "90%",
      mode: "-",
      number: "10",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "15",
      quality: "-",
      processing: "Cutting",
      speed: "300",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: "1200",
      max: "900",
      mode: "-",
      number: "10",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "15",
      quality: "-",
      processing: "Cutting",
      speed: "300",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Yellow peach wood",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "40%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Yellow peach wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "400",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "40%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "25",
      quality: "-",
      processing: "Cutting",
      speed: "1100",
      max: "90%",
      mode: "-",
      number: "10",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: "120",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "400",
      mode: "-",
      number: "1",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "25",
      quality: "-",
      processing: "Cutting",
      speed: "1100",
      max: "900",
      mode: "-",
      number: "10",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: "120",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "90%",
      mode: "-",
      number: "2",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "18",
      quality: "-",
      processing: "Cutting",
      speed: "350",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "20",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "900",
      mode: "-",
      number: "2",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "18",
      quality: "-",
      processing: "Cutting",
      speed: "350",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Cork wood",
      software: "LightBurn",
      thickness: "18",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Cork wood",
      software: "LaserGRBL",
      thickness: "18",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "45%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "450",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "35%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "4",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "90%",
      mode: "-",
      number: "5",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "350",
      mode: "-",
      number: "1",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "4",
      quality: "-",
      processing: "Cutting",
      speed: "800",
      max: "900",
      mode: "-",
      number: "5",
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "20%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "200",
      mode: "-",
      number: "1",
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "Ceramic Tile",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "8000",
      max: "30%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Ceramic Tile",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "8000",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "Alumina",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "55%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Alumina",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "550",
      mode: "-",
      number: "1",
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "6000",
      max: "50%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "6000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "50%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "26",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "90%",
      mode: "-",
      number: "10",
    },
    {
      name: "Acrylic",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "26",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "900",
      mode: "-",
      number: "10",
    },
    {
      name: "Acrylic",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: "100",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Translucent Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "8000",
      max: "30%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Translucent Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "8000",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "Two color plate",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "7000",
      max: "20%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Two color plate",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "7000",
      max: "200",
      mode: "-",
      number: "1",
    },
    {
      name: "Plastic",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "45%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "10000",
      max: "450",
      mode: "-",
      number: "1",
    },
    {
      name: "High density foam board",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "8000",
      max: "13%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "High density foam board",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "8000",
      max: "130",
      mode: "-",
      number: "1",
    },
    {
      name: "Rubber",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "8000",
      max: "35%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Rubber",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "8000",
      max: "350",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "9000",
      max: "30%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: "9000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "9000",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: "9000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Office Paper",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "27%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Office Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "270",
      mode: "-",
      number: "1",
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "8000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Carton",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "8000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: "0.09",
      processing: "Engraving",
      speed: "10000",
      max: "25%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "12",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "90%",
      mode: "-",
      number: "6",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "9",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: "11",
      processing: "Engraving",
      speed: "10000",
      max: "250",
      mode: "-",
      number: "1",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "12",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "900",
      mode: "-",
      number: "6",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "9",
      quality: "-",
      processing: "Cutting",
      speed: "200",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Galvanized Iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: "90%",
      mode: "-",
      number: 1,
    },
    {
      name: "Stainless Steel Sheet",
      software: "LightBurn",
      thickness: "0.05",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "60%",
      mode: "-",
      number: "1",
    },
    {
      name: "Stainless Steel Sheet",
      software: "LaserGRBL",
      thickness: "0.05",
      quality: "-",
      processing: "Cutting",
      speed: "1000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "EVa Foam",
      software: "LightBurn",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: "1500",
      max: "30%",
      mode: "-",
      number: "1",
    },
    {
      name: "EVa Foam",
      software: "LaserGRBL",
      thickness: "8",
      quality: "-",
      processing: "Cutting",
      speed: "1500",
      max: "300",
      mode: "-",
      number: "1",
    },
    {
      name: "Glutinous rice paper",
      software: "LightBurn",
      thickness: "0.5",
      quality: "-",
      processing: "Cutting",
      speed: "500",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Glutinous rice paper",
      software: "LaserGRBL",
      thickness: "0.5",
      quality: "-",
      processing: "Cutting",
      speed: "500",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Woolen Blanket",
      software: "LightBurn",
      thickness: "1.5",
      quality: "-",
      processing: "Cutting",
      speed: "2000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "Woolen Blanket",
      software: "LaserGRBL",
      thickness: "1.5",
      quality: "-",
      processing: "Cutting",
      speed: "2000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "denim",
      software: "LightBurn",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: "5000",
      max: "90%",
      mode: "-",
      number: "1",
    },
    {
      name: "denim",
      software: "LaserGRBL",
      thickness: "0.6",
      quality: "-",
      processing: "Cutting",
      speed: "5000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "10000",
      max: "35%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "10000",
      max: "350",
      mode: "-",
      number: "1",
    },
    {
      name: "Rock",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Rock",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "10000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "Crystal Stone",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "7000",
      max: "40%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Crystal Stone",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "7000",
      max: "400",
      mode: "-",
      number: "1",
    },
    {
      nname: "PCB Board",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "8000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "PCB Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "8000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "Hard maple",
      software: "LightBurn",
      thickness: "-",
      quality: "0.08",
      processing: "Engraving",
      speed: "10000",
      max: "60%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Hard maple",
      software: "LaserGRBL",
      thickness: "-",
      quality: "12",
      processing: "Engraving",
      speed: "10000",
      max: "600",
      mode: "-",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "6000",
      max: "50%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: "15",
      processing: "Engraving",
      speed: "6000",
      max: "500",
      mode: "-",
      number: "1",
    },
    {
      name: "Galvanized iron",
      software: "LightBurn",
      thickness: "-",
      quality: "0.05",
      processing: "Engraving",
      speed: "3000",
      max: "90%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Galvanized iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: "15",
      processing: "Engraving",
      speed: "3000",
      max: "900",
      mode: "-",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Iron sheet",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "6000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "6000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Brass",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "2000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Brass",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "2000",
      max: "800",
      mode: "-",
      number: "1",
    },
    {
      name: "Wrench (chrome -vanadium alloy)",
      software: "LightBurn",
      thickness: "-",
      quality: "0.1",
      processing: "Engraving",
      speed: "3000",
      max: "80%",
      mode: "Stuick",
      number: "1",
    },
    {
      name: "Wrench (chrome -vanadium alloy)",
      software: "LaserGRBL",
      thickness: "-",
      quality: "10",
      processing: "Engraving",
      speed: "3000",
      max: "800",
      mode: "-",
      number: "1",
    },
  ],

  P9M50: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "25%",
      mode: "Jarvis",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 450,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 900,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 300,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 450,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "25%",
      mode: "Jarvis",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 260,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 400,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 250,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 370,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "30%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 900,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 400,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "1.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "1.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 1400,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "1.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "25%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 180,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 360,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 570,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 300,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 180,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 360,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 550,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Jarvis",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 5000,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 7500,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 150,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 5000,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 9000,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 250,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "15%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 180,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 2000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 400,
      max: "70%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 400,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "70%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 400,
      max: "100%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 400,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
  ],
  P9M40: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 5000,
      max: "60%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 250,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 450,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 650,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 700,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 360,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 450,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 650,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "70%",
      mode: "Jarvis",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 90,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 160,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 240,
      max: "100%",
      mode: "-",
      number: 5,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 700,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 80,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 150,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 230,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "60%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 700,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "1.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "1.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 550,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "1.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 850,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "70%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 110,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 210,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 700,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 120,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 220,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 320,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Jarvis",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 3000,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 5500,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 7000,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 5500,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "60%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 700,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "25%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 250,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.067,
      processing: "Engraving",
      speed: 400,
      max: "100%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 15,
      processing: "Engraving",
      speed: 400,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
  ],
  P7M40: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 5000,
      max: "60%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 250,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 450,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 650,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 700,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 360,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 450,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 650,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "70%",
      mode: "Jarvis",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 90,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 160,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 240,
      max: "100%",
      mode: "-",
      number: 5,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 700,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 80,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 150,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 230,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "60%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 700,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "1.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "1.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 550,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "1.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 850,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "70%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 110,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 210,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 700,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 120,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 220,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 320,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Jarvis",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 3000,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 5500,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 7000,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 5500,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "60%",
      mode: "Jarvis",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 700,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "25%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 250,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.067,
      processing: "Engraving",
      speed: 400,
      max: "100%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 15,
      processing: "Engraving",
      speed: 400,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
  ],
  P7M30: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 5000,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 110,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 220,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 310,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 2000,
      max: 500,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 110,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 210,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "2.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 310,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "80%",
      mode: "Jarvis",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 180,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LightBurn",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "100%",
      mode: "-",
      number: 5,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 2000,
      max: 500,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Hardwood",
      software: "LaserGRBL",
      thickness: "5.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 220,
      max: 1000,
      mode: "-",
      number: 5,
      color: "#f8f8f8",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "80%",
      mode: "Jarvis",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 320,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 2000,
      max: 700,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 310,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 60,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 140,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 210,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 2000,
      max: 500,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 120,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "2.8mm",
      quality: "-",
      processing: "Cutting",
      speed: 320,
      max: 1000,
      mode: "-",
      number: 5,
      color: "#f8f8f8",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Jarvis",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 1200,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 2500,
      max: "100%",
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 3600,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 2000,
      max: 280,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: 1000,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 3000,
      max: 1000,
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "70%",
      mode: "Jarvis",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 2000,
      max: 450,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 2000,
      max: 230,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
  ],
  // S30Pro: [
  //   {
  //     name: 'Basswood',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LightBurn',
  //     thickness: '14mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 600,
  //     max: '80%',
  //     mode: '-',
  //     number: 9,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LightBurn',
  //     thickness: '11mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 130,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LaserGRBL',
  //     thickness: '14mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 600,
  //     max: 800,
  //     mode: '-',
  //     number: 9,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LaserGRBL',
  //     thickness: '11mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 130,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Yellow peach wood',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: '15%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Yellow peach wood',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: 150,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 5000,
  //     max: '20%',
  //     mode: 'Jarvis',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LightBurn',
  //     thickness: '15mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 600,
  //     max: '80%',
  //     mode: '-',
  //     number: 10,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LightBurn',
  //     thickness: '12mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 5000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LaserGRBL',
  //     thickness: '15mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 600,
  //     max: 800,
  //     mode: '-',
  //     number: 10,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LaserGRBL',
  //     thickness: '12mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Paulownia wood',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: '45%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia wood',
  //     software: 'LightBurn',
  //     thickness: '14mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 200,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia wood',
  //     software: 'LightBurn',
  //     thickness: '20mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 750,
  //     max: '70%',
  //     mode: '-',
  //     number: 9,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia wood',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: 450,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia wood',
  //     software: 'LaserGRBL',
  //     thickness: '20mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 750,
  //     max: 700,
  //     mode: '-',
  //     number: 9,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia wood',
  //     software: 'LaserGRBL',
  //     thickness: '14mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 200,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Cork wood',
  //     software: 'LightBurn',
  //     thickness: '15mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 500,
  //     max: '100%',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Cork wood',
  //     software: 'LaserGRBL',
  //     thickness: '15mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 500,
  //     max: 1000,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: '50%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LightBurn',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 400,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: 500,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LaserGRBL',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 400,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Leather',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Leather',
  //     software: 'LightBurn',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 1000,
  //     max: '60%',
  //     mode: '-',
  //     number: 5,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Leather',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Leather',
  //     software: 'LaserGRBL',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 1000,
  //     max: 600,
  //     mode: '-',
  //     number: 5,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Denim',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Ceramics',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.05,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Ceramics',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 20,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Ceramics',
  //     software: 'LaserGRBL',
  //     thickness: '0.2mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: '-',
  //     max: '-',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Ceramic tile',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 2200,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Ceramic tile',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 2200,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Alumina',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.01,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: '60%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Alumina',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 100,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 600,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Mirrors',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.08,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: '30%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Mirrors',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 12,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: 300,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Glass',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 1500,
  //     max: '50%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Glass',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 1500,
  //     max: 500,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Glass',
  //     software: 'LaserGRBL',
  //     thickness: '4mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: '-',
  //     max: '-',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: '50%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LightBurn',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LightBurn',
  //     thickness: '20mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: '80%',
  //     mode: '-',
  //     number: 10,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: 500,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LaserGRBL',
  //     thickness: '20mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: 800,
  //     mode: '-',
  //     number: 10,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LaserGRBL',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Translucent Acrylic',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: '13%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Translucent Acrylic',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: 130,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Two color plate',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 5000,
  //     max: '12%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Two color plate',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 5000,
  //     max: 120,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Plastic',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Plastic',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Plastic',
  //     software: 'LaserGRBL',
  //     thickness: '14mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: '-',
  //     max: '-',
  //     mode: '-',
  //     number: 7,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Plastic',
  //     software: 'LaserGRBL',
  //     thickness: '9mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: '-',
  //     max: '-',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Resin',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 1500,
  //     max: '13%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Resin',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 1500,
  //     max: 130,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'High density\nfoam board',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 5000,
  //     max: '9%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'High density\nfoam board',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 5000,
  //     max: 90,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Rubber',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 5000,
  //     max: '50%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Rubber',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 5000,
  //     max: 500,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Kraft Paper',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: '15%',
  //     mode: 'Jarvis',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Kraft Paper',
  //     software: 'LightBurn',
  //     thickness: '0.6mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 2000,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Kraft Paper',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: 150,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Kraft Paper',
  //     software: 'LaserGRBL',
  //     thickness: '0.6mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 2000,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Office paper',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.125,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '13%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Office paper',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 8,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 130,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Glutinous rice paper',
  //     software: 'LightBurn',
  //     thickness: '0.5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 300,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Glutinous rice paper',
  //     software: 'LaserGRBL',
  //     thickness: '0.5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 300,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Drywall',
  //     software: 'LightBurn',
  //     thickness: '15mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Drywall',
  //     software: 'LaserGRBL',
  //     thickness: '15mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Carton',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '15%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Carton',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 150,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.085,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LightBurn',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 350,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LightBurn',
  //     thickness: '8mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 1000,
  //     max: '80%',
  //     mode: '-',
  //     number: 7,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 12,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LaserGRBL',
  //     thickness: '8mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 1000,
  //     max: 800,
  //     mode: '-',
  //     number: 7,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LaserGRBL',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 350,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Mirrors',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.08,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: '30%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Mirrors',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 12,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: 300,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Mirrors',
  //     software: 'LaserGRBL',
  //     thickness: '8mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: '-',
  //     max: '-',
  //     mode: '-',
  //     number: 7,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Mirrors',
  //     software: 'LaserGRBL',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: '-',
  //     max: '-',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Rock',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: '60%',
  //     mode: 'Filled',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Rock',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: 600,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Crystal Stone',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 2000,
  //     max: '25%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Crystal Stone',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 2000,
  //     max: 250,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'PCB Board',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 4000,
  //     max: '55%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'PCB Board',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 4000,
  //     max: 550,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Mirror Stainless Steel',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 2000,
  //     max: '60%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Mirror Stainless Steel',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 2000,
  //     max: 600,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Brushed Stainless Steel',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.08,
  //     processing: 'Engraving',
  //     speed: 1500,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Brushed Stainless Steel',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 12,
  //     processing: 'Engraving',
  //     speed: 1500,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Stainless Steel\nSheet',
  //     software: 'LightBurn',
  //     thickness: '0.05mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 1000,
  //     max: '60%',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: '-',
  //     software: 'LaserGRBL',
  //     thickness: '0.05mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 1000,
  //     max: 600,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Galvanized iron',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 200,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Galvanized iron',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 200,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Iron sheet',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 500,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Iron sheet',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 500,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Brass',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Brass',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Transparent Polycarbonate',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: '15%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Transparent Polycarbonate',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 7000,
  //     max: 150,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Wrench (chrome- vanadium alloy)',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 500,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Wrench (chrome- vanadium alloy)',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 500,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Cobble Stone',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: '60%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Cobble Stone',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 6000,
  //     max: 600,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'EVa Foam',
  //     software: 'LaserGRBL',
  //     thickness: '8mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 1500,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'EVa Foam',
  //     software: 'LightBurn',
  //     thickness: '8mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 1500,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  // ],
  // S20Pro: [
  //   {
  //     name: 'Basswood',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LightBurn',
  //     thickness: '10mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 600,
  //     max: '75%',
  //     mode: '-',
  //     number: 6,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LightBurn',
  //     thickness: '8mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 200,
  //     max: '100%',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LaserGRBL',
  //     thickness: '10mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 600,
  //     max: 800,
  //     mode: '-',
  //     number: 5,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LaserGRBL',
  //     thickness: '8mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 200,
  //     max: 1000,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Paulownia Wood',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 2700,
  //     max: '45%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia Wood',
  //     software: 'LightBurn',
  //     thickness: '18mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 320,
  //     max: '70%',
  //     mode: '-',
  //     number: 10,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia Wood',
  //     software: 'LightBurn',
  //     thickness: '12mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 260,
  //     max: '100%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia Wood',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 350,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia Wood',
  //     software: 'LaserGRBL',
  //     thickness: '18mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 400,
  //     max: 800,
  //     mode: '-',
  //     number: 6,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia Wood',
  //     software: 'LaserGRBL',
  //     thickness: '12mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 220,
  //     max: 1000,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Cork Wood',
  //     software: 'LightBurn',
  //     thickness: '15mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 2000,
  //     max: '70%',
  //     mode: '-',
  //     number: 10,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Cork Wood',
  //     software: 'LightBurn',
  //     thickness: '10mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 600,
  //     max: '100%',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Cork Wood',
  //     software: 'LaserGRBL',
  //     thickness: '15mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 700,
  //     max: 850,
  //     mode: '-',
  //     number: 2,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Cork Wood',
  //     software: 'LaserGRBL',
  //     thickness: '10mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 420,
  //     max: 1000,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Yellow Peach Wood',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '15%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Yellow Peach Wood',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '50%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LightBurn',
  //     thickness: '6mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 550,
  //     max: '100%',
  //     mode: '-',
  //     number: 3,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LightBurn',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 400,
  //     max: '100%',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 500,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LaserGRBL',
  //     thickness: '6mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 400,
  //     max: 800,
  //     mode: '-',
  //     number: 3,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LaserGRBL',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 360,
  //     max: 1000,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '50%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LightBurn',
  //     thickness: '15mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: '65%',
  //     mode: '-',
  //     number: 10,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LightBurn',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: '100%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 500,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LaserGRBL',
  //     thickness: '15mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: 600,
  //     mode: '-',
  //     number: 8,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LaserGRBL',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: 1000,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Translucent Acrylic',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '13%',
  //     mode: 'Jarvis',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Kraft Paper',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '15%',
  //     mode: 'Jarvis',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Kraft Paper',
  //     software: 'LightBurn',
  //     thickness: '0.2mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 3000,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Kraft Paper',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 140,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Kraft Paper',
  //     software: 'LaserGRBL',
  //     thickness: '0.2mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 3000,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Office Paper',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.125,
  //     processing: 'Engraving',
  //     speed: 1500,
  //     max: '13%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Office Paper',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 8,
  //     processing: 'Engraving',
  //     speed: 1500,
  //     max: 120,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Oil Painting Paper',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '23%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Oil Painting Paper',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 250,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Mirrors',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.08,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '30%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Mirrors',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 12,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 300,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Leather',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Leather',
  //     software: 'LightBurn',
  //     thickness: '2mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 300,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Leather',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Leather',
  //     software: 'LaserGRBL',
  //     thickness: '4mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 200,
  //     max: 1000,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Stainless Steel Sheet',
  //     software: 'LightBurn',
  //     thickness: '0.05mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 500,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Stainless Steel Sheet',
  //     software: 'LaserGRBL',
  //     thickness: '0.05mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 600,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Mirror Stainless Steel',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 600,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Mirror Stainless Steel',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 600,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Brushed Stainless Steel',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.08,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Brushed Stainless Steel',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 12,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '20%',
  //     mode: 'Jarvis',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LightBurn',
  //     thickness: '9mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 280,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LightBurn',
  //     thickness: '14mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 130,
  //     max: '100%',
  //     mode: '-',
  //     number: 10,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LaserGRBL',
  //     thickness: '14mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 300,
  //     max: 800,
  //     mode: '-',
  //     number: 7,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LaserGRBL',
  //     thickness: '9mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 120,
  //     max: 1000,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Ceramics',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Ceramics',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Ceramics Tile',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Ceramics Tile',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Alumina',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 500,
  //     max: '60%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Alumina',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 600,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Glass',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: '-',
  //     max: '-',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Glass',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 500,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Denim',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Denim',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Plastic',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Plastic',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Carton',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '15%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Carton',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 120,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.085,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '20%',
  //     mode: 'Atkinson',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LightBurn',
  //     thickness: '8mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 400,
  //     max: '100%',
  //     mode: '-',
  //     number: 4,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LightBurn',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 160,
  //     max: '100%',
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 12,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 180,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LaserGRBL',
  //     thickness: '8mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 400,
  //     max: 1000,
  //     mode: '-',
  //     number: 7,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LaserGRBL',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 160,
  //     max: 1000,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Galvanized Iron',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 100,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Galvanized Iron',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 500,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Rock',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '60%',
  //     mode: 'Filled',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Rock',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 600,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Crystal Stone',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: '65%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Cobblestone',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '60%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Cobblestone',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 600,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'PCB Board',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 2000,
  //     max: '60%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'PCB Board',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 2000,
  //     max: 650,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'High Density Foam Board',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '15%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'High Density Foam Board',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 120,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Mahogany',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '35%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Mahogany',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 300,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Two Color Plate',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '12%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Two Color Plate',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 100,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Resin',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: '13%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Resin',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 150,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Artificial Beef Bone',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: '30%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Artificial Beef Bone',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 240,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Rubber',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '50%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Rubber',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 500,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Iron Sheet',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 100,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Iron Sheet',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 500,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Artificial Agate',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 50,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Artificial Agate',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 12,
  //     processing: 'Engraving',
  //     speed: 100,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  // ],
  // S10Pro: [
  //   {
  //     name: 'Basswood',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '25%',
  //     mode: 'Jarvis',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LightBurn',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 700,
  //     max: '80%',
  //     mode: '-',
  //     number: 5,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LightBurn',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 1000,
  //     max: '80%',
  //     mode: '-',
  //     number: 8,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 8,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 300,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Basswood',
  //     software: 'LaserGRBL',
  //     thickness: '5mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 700,
  //     max: 800,
  //     mode: '-',
  //     number: 10,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Paulownia Wood',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '50%',
  //     mode: 'Jarvis',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia Wood',
  //     software: 'LightBurn',
  //     thickness: '8mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 700,
  //     max: '80%',
  //     mode: '-',
  //     number: 8,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia Wood',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 8,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '50%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Paulownia Wood',
  //     software: 'LaserGRBL',
  //     thickness: '8mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 700,
  //     max: 800,
  //     mode: '-',
  //     number: 10,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Cork Wood',
  //     software: 'LightBurn',
  //     thickness: '10mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 1800,
  //     max: '80%',
  //     mode: '-',
  //     number: 10,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Cork Wood',
  //     software: 'LaserGRBL',
  //     thickness: '10mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 1200,
  //     max: 800,
  //     mode: '-',
  //     number: 10,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '30%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LightBurn',
  //     thickness: '2mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 400,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 8,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 400,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Bamboo',
  //     software: 'LaserGRBL',
  //     thickness: '2mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 900,
  //     max: 800,
  //     mode: '-',
  //     number: 8,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '25%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LightBurn',
  //     thickness: '10mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: '80%',
  //     mode: '-',
  //     number: 5,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 8,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 300,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Opaque Acrylic',
  //     software: 'LaserGRBL',
  //     thickness: '10mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: 800,
  //     mode: '-',
  //     number: 10,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Kraft Paper',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '20%',
  //     mode: 'Jarvis',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Kraft Paper',
  //     software: 'LightBurn',
  //     thickness: '0.2mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 3500,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Kraft Paper',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 8,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 150,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Kraft Paper',
  //     software: 'LaserGRBL',
  //     thickness: '0.2mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 3500,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Office Paper',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 1500,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Office Paper',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 2000,
  //     max: 350,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Oil Painting Paper',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '30%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Oil Painting Paper',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 150,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Mirrors',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Mirrors',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 8,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 250,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Leather',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '15%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Leather',
  //     software: 'LightBurn',
  //     thickness: '2mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: '80%',
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Leather',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 8,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 180,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Leather',
  //     software: 'LaserGRBL',
  //     thickness: '2mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 100,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Mirror Stainless Steel',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 100,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Mirror Stainless Steel',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 12,
  //     processing: 'Engraving',
  //     speed: 100,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Brushed Stainless Steel',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.08,
  //     processing: 'Engraving',
  //     speed: 300,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Stainless Steel',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 400,
  //     max: 1000,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '25%',
  //     mode: 'Jarvis',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LightBurn',
  //     thickness: '7mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 300,
  //     max: '80%',
  //     mode: '-',
  //     number: 8,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 8,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 400,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Pine',
  //     software: 'LaserGRBL',
  //     thickness: '7mm',
  //     quality: '-',
  //     processing: 'Cutting',
  //     speed: 300,
  //     max: 800,
  //     mode: '-',
  //     number: 6,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Ceramics',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 400,
  //     max: '70%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Ceramics',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 400,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Ceramics Tile',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 500,
  //     max: '70%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Ceramics Tile',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 500,
  //     max: 600,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Alumina',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 500,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Alumina',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 12,
  //     processing: 'Engraving',
  //     speed: 500,
  //     max: 700,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Glass',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: '70%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Glass',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Plastic',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Plastic',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 300,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Denim',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 2000,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Denim',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 8,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Carton',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '50%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Carton',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.08,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: '20%',
  //     mode: 'Atkinson',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'MDF',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 3000,
  //     max: 300,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Galvanized Iron',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 100,
  //     max: '80%',
  //     mode: 'Jarvis',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Galvanized Iron',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 100,
  //     max: 800,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Rock',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: '80%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Rock',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 1000,
  //     max: 700,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'Crystal Stone',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 500,
  //     max: '20%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'Crystal Stone',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 500,
  //     max: 200,
  //     mode: '-',
  //     number: 1,
  //     color: '#d1e1fc',
  //   },
  //   {
  //     name: 'PCB Board',
  //     software: 'LightBurn',
  //     thickness: '-',
  //     quality: 0.1,
  //     processing: 'Engraving',
  //     speed: 2000,
  //     max: '70%',
  //     mode: 'Threshold',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  //   {
  //     name: 'PCB Board',
  //     software: 'LaserGRBL',
  //     thickness: '-',
  //     quality: 10,
  //     processing: 'Engraving',
  //     speed: 2000,
  //     max: 400,
  //     mode: '-',
  //     number: 1,
  //     color: '#f8f8f8',
  //   },
  // ],
  X30Pro: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 6000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: "80%",
      mode: "-",
      number: 9,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "11mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: 800,
      mode: "-",
      number: 9,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "11mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Yellow peach wood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 7000,
      max: "15%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Yellow peach wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 7000,
      max: 150,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 5000,
      max: "20%",
      mode: "Jarvis",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: "80%",
      mode: "-",
      number: 10,
      color: "#d1e1fc",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 5000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: 800,
      mode: "-",
      number: 10,
      color: "#d1e1fc",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Paulownia wood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 7000,
      max: "45%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Paulownia wood",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Paulownia wood",
      software: "LightBurn",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 750,
      max: "70%",
      mode: "-",
      number: 9,
      color: "#f8f8f8",
    },
    {
      name: "Paulownia wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 7000,
      max: 450,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Paulownia wood",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 750,
      max: 700,
      mode: "-",
      number: 9,
      color: "#f8f8f8",
    },
    {
      name: "Paulownia wood",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Cork wood",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Cork wood",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 7000,
      max: "50%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 7000,
      max: 500,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 6000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "60%",
      mode: "-",
      number: 5,
      color: "#d1e1fc",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 5,
      color: "#d1e1fc",
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: 0.05,
      processing: "Engraving",
      speed: 1000,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: 20,
      processing: "Engraving",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: "-",
      max: "-",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Ceramic tile",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 2200,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Ceramic tile",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 2200,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Alumina",
      software: "LightBurn",
      thickness: "-",
      quality: 0.01,
      processing: "Engraving",
      speed: 1000,
      max: "60%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Alumina",
      software: "LaserGRBL",
      thickness: "-",
      quality: 100,
      processing: "Engraving",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 7000,
      max: "30%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 7000,
      max: 300,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1500,
      max: "50%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1500,
      max: 500,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "4mm",
      quality: "-",
      processing: "Cutting",
      speed: "-",
      max: "-",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 6000,
      max: "50%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "80%",
      mode: "-",
      number: 10,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: 500,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "20mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 10,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Translucent Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 6000,
      max: "13%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Translucent Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: 130,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Two color plate",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 5000,
      max: "12%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Two color plate",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 5000,
      max: 120,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Plastic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 6000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: "-",
      max: "-",
      mode: "-",
      number: 7,
      color: "#d1e1fc",
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "9mm",
      quality: "-",
      processing: "Cutting",
      speed: "-",
      max: "-",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Resin",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1500,
      max: "13%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Resin",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1500,
      max: 130,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "High density\nfoam board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 5000,
      max: "9%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "High density\nfoam board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 5000,
      max: 90,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Rubber",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 5000,
      max: "50%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Rubber",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 5000,
      max: 500,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 7000,
      max: "15%",
      mode: "Jarvis",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.6mm",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 7000,
      max: 150,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.6mm",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Office paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.125,
      processing: "Engraving",
      speed: 3000,
      max: "13%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Office paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 130,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Glutinous rice paper",
      software: "LightBurn",
      thickness: "0.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Glutinous rice paper",
      software: "LaserGRBL",
      thickness: "0.5mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Drywall",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Drywall",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "15%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Carton",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 150,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.085,
      processing: "Engraving",
      speed: 6000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 350,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "80%",
      mode: "-",
      number: 7,
      color: "#f8f8f8",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 6000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 7,
      color: "#f8f8f8",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 350,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 7000,
      max: "30%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 7000,
      max: 300,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: "-",
      max: "-",
      mode: "-",
      number: 7,
      color: "#d1e1fc",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: "-",
      max: "-",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Rock",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 6000,
      max: "60%",
      mode: "Filled",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Rock",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: 600,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Crystal Stone",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 2000,
      max: "25%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Crystal Stone",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 2000,
      max: 250,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "PCB Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 4000,
      max: "55%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "PCB Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 4000,
      max: 550,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Mirror Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 2000,
      max: "60%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Mirror Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 2000,
      max: 600,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 1500,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 1500,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Stainless Steel\nSheet",
      software: "LightBurn",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "60%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "-",
      software: "LaserGRBL",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Galvanized iron",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 200,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Galvanized iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 200,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Iron sheet",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 500,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Iron sheet",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 500,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Brass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Brass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Transparent Polycarbonate",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 7000,
      max: "15%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Transparent Polycarbonate",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 7000,
      max: 150,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Wrench (chrome- vanadium alloy)",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 500,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Wrench (chrome- vanadium alloy)",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 500,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Cobble Stone",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 6000,
      max: "60%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Cobble Stone",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 6000,
      max: 600,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "EVa Foam",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 1500,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "EVa Foam",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 1500,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
  ],
  X20Pro: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: "75%",
      mode: "-",
      number: 6,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: 800,
      mode: "-",
      number: 5,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 2700,
      max: "45%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: 320,
      max: "70%",
      mode: "-",
      number: 10,
      color: "#f8f8f8",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 260,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 350,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "18mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: 800,
      mode: "-",
      number: 6,
      color: "#f8f8f8",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "12mm",
      quality: "-",
      processing: "Cutting",
      speed: 220,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Cork Wood",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 2000,
      max: "70%",
      mode: "-",
      number: 10,
      color: "#d1e1fc",
    },
    {
      name: "Cork Wood",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Cork Wood",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: 850,
      mode: "-",
      number: 2,
      color: "#d1e1fc",
    },
    {
      name: "Cork Wood",
      software: "LaserGRBL",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 420,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Yellow Peach Wood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "15%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Yellow Peach Wood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "50%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "6mm",
      quality: "-",
      processing: "Cutting",
      speed: 550,
      max: "100%",
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 500,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "6mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: 800,
      mode: "-",
      number: 3,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 360,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "50%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "65%",
      mode: "-",
      number: 10,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 500,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "15mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 600,
      mode: "-",
      number: 8,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Translucent Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "13%",
      mode: "Jarvis",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "15%",
      mode: "Jarvis",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 3000,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 140,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 3000,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Office Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.125,
      processing: "Engraving",
      speed: 1500,
      max: "13%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Office Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 1500,
      max: 120,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Oil Painting Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "23%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Oil Painting Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 250,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "30%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: 300,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "4mm",
      quality: "-",
      processing: "Cutting",
      speed: 200,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Stainless Steel Sheet",
      software: "LightBurn",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: 500,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Stainless Steel Sheet",
      software: "LaserGRBL",
      thickness: "0.05mm",
      quality: "-",
      processing: "Cutting",
      speed: 600,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Mirror Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 600,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Mirror Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 600,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 1000,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Jarvis",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "9mm",
      quality: "-",
      processing: "Cutting",
      speed: 130,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 280,
      max: "80%",
      mode: "-",
      number: 10,
      color: "#f8f8f8",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "14mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: 800,
      mode: "-",
      number: 7,
      color: "#f8f8f8",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "9mm",
      quality: "-",
      processing: "Cutting",
      speed: 120,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Ceramics Tile",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Ceramics Tile",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Alumina",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 500,
      max: "60%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Alumina",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 600,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "50%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 500,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Plastic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "15%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Carton",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 120,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.085,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Atkinson",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: "100%",
      mode: "-",
      number: 4,
      color: "#f8f8f8",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 160,
      max: "100%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 3000,
      max: 180,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: 1000,
      mode: "-",
      number: 7,
      color: "#f8f8f8",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 160,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Galvanized Iron",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 100,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Galvanized Iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 500,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Rock",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "60%",
      mode: "Filled",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Rock",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 600,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Crystal Stone",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "65%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Cobblestone",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "60%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Cobblestone",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 600,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "PCB Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 2000,
      max: "60%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "PCB Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 2000,
      max: 650,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "High Density Foam Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "15%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "High Density Foam Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 120,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Mahogany",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "35%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Mahogany",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 300,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Two Color Plate",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "12%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Two Color Plate",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 100,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Resin",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "13%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Resin",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 150,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Artificial Beef Bone",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "30%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Artificial Beef Bone",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 240,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Rubber",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "50%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Rubber",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 500,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Iron Sheet",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 100,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Iron Sheet",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 500,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Artificial Agate",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 50,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Artificial Agate",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
  ],
  X7Pro: [
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "25%",
      mode: "Jarvis",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: "80%",
      mode: "-",
      number: 5,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LightBurn",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 1000,
      max: "80%",
      mode: "-",
      number: 8,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 300,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Basswood",
      software: "LaserGRBL",
      thickness: "5mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: 800,
      mode: "-",
      number: 10,
      color: "#d1e1fc",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "50%",
      mode: "Jarvis",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Paulownia Wood",
      software: "LightBurn",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: "80%",
      mode: "-",
      number: 8,
      color: "#f8f8f8",
    },
    {
      name: "Paulownia Wood",
      software: "LaserGRBL",
      thickness: "8mm",
      quality: "-",
      processing: "Cutting",
      speed: 700,
      max: 800,
      mode: "-",
      number: 10,
      color: "#f8f8f8",
    },
    {
      name: "Cork Wood",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 1800,
      max: "80%",
      mode: "-",
      number: 10,
      color: "#d1e1fc",
    },
    {
      name: "Cork Wood",
      software: "LaserGRBL",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 1200,
      max: 800,
      mode: "-",
      number: 10,
      color: "#d1e1fc",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "30%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Bamboo",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 400,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 400,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Bamboo",
      software: "LaserGRBL",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 900,
      max: 800,
      mode: "-",
      number: 8,
      color: "#f8f8f8",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "25%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Opaque Acrylic",
      software: "LightBurn",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "80%",
      mode: "-",
      number: 5,
      color: "#d1e1fc",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 300,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Opaque Acrylic",
      software: "LaserGRBL",
      thickness: "10mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 10,
      color: "#d1e1fc",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Jarvis",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Kraft Paper",
      software: "LightBurn",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 3500,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 150,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Kraft Paper",
      software: "LaserGRBL",
      thickness: "0.2mm",
      quality: "-",
      processing: "Cutting",
      speed: 3500,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Office Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1500,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Office Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 2000,
      max: 350,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Oil Painting Paper",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "30%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Oil Painting Paper",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 150,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Mirrors",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Mirrors",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 150,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "15%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Leather",
      software: "LightBurn",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: "80%",
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 180,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Leather",
      software: "LaserGRBL",
      thickness: "2mm",
      quality: "-",
      processing: "Cutting",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Mirror Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 100,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Mirror Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Brushed Stainless Steel",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 300,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Stainless Steel",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 400,
      max: 1000,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "25%",
      mode: "Jarvis",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Pine",
      software: "LightBurn",
      thickness: "7mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: "80%",
      mode: "-",
      number: 8,
      color: "#f8f8f8",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 400,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Pine",
      software: "LaserGRBL",
      thickness: "7mm",
      quality: "-",
      processing: "Cutting",
      speed: 300,
      max: 800,
      mode: "-",
      number: 6,
      color: "#f8f8f8",
    },
    {
      name: "Ceramics",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 400,
      max: "70%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Ceramics",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 400,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Ceramics Tile",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 500,
      max: "70%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Ceramics Tile",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 500,
      max: 600,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Alumina",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 500,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Alumina",
      software: "LaserGRBL",
      thickness: "-",
      quality: 12,
      processing: "Engraving",
      speed: 500,
      max: 700,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Glass",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "70%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Glass",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 800,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Plastic",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Plastic",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 300,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Denim",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 2000,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Denim",
      software: "LaserGRBL",
      thickness: "-",
      quality: 8,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Carton",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 3000,
      max: "50%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Carton",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 200,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "MDF",
      software: "LightBurn",
      thickness: "-",
      quality: 0.08,
      processing: "Engraving",
      speed: 3000,
      max: "20%",
      mode: "Atkinson",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "MDF",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 3000,
      max: 300,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Galvanized Iron",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 100,
      max: "80%",
      mode: "Jarvis",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Galvanized Iron",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 100,
      max: 800,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Rock",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 1000,
      max: "80%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Rock",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 1000,
      max: 700,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "Crystal Stone",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 500,
      max: "20%",
      mode: "Threshold",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "Crystal Stone",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 500,
      max: 200,
      mode: "-",
      number: 1,
      color: "#d1e1fc",
    },
    {
      name: "PCB Board",
      software: "LightBurn",
      thickness: "-",
      quality: 0.1,
      processing: "Engraving",
      speed: 2000,
      max: "70%",
      mode: "Threshold",
      number: 1,
      color: "#f8f8f8",
    },
    {
      name: "PCB Board",
      software: "LaserGRBL",
      thickness: "-",
      quality: 10,
      processing: "Engraving",
      speed: 2000,
      max: 400,
      mode: "-",
      number: 1,
      color: "#f8f8f8",
    },
  ],
};
